import _taggedTemplateLiteral from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import styled from 'styled-components';
import { Wrapper as Button } from '@spa/shared/components/Unisystem/Button/styles';
import { mediaMin } from '@spa/shared/theme';
export var Form = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1y8d5qz-0"
})(["display:flex;flex-direction:column;align-items:flex-start;", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(5, 'column');
});
export var Separator = /*#__PURE__*/styled.hr.withConfig({
  componentId: "sc-1y8d5qz-1"
})(["border:0;border-top:", ";margin:", " 0;"], function (props) {
  return "1px solid ".concat(props.theme.colors.shadyGray);
}, function (props) {
  return props.theme.space(5);
});
export var Buttons = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1y8d5qz-2"
})(["display:flex;", ";width:100%;", "{width:25%;max-width:160px;", "}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.gap(3);
}, Button, mediaMin.mediumBreakpoint(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      width: 50%;\n      max-width: 50%;\n    "]))));